import { REDUCER_NAME } from './const'

export const WHATSAPP_MESSAGES_TABLE = 'freshchatWhatsappTable'

const NS =  REDUCER_NAME + '/'

export const WHATSAPP_DELIVERED_MESSAGE_LIST = NS + 'WHATSAPP_DELIVERED_MESSAGE_LIST'

export const FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST = NS + 'FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST'
export const FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS = NS + 'FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS'
export const FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR = NS + 'FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR'




// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/state/type.js